export type FormulaTokenChip = {
  token: string;
  labelKey: string;
};

export type FormulaTokenGroup = {
  id: string;
  labelKey: string;
  tokens: FormulaTokenChip[];
};

export const FORMULA_TOKEN_GROUPS: FormulaTokenGroup[] = [
  {
    id: "range",
    labelKey: "visualEditor.formulaGroupRange",
    tokens: [
      { token: "{{range.days}}", labelKey: "visualEditor.columnFormulaInsertDays" },
      { token: "{{range.hours}}", labelKey: "visualEditor.columnFormulaInsertHours" },
      { token: "{{range.minutes}}", labelKey: "visualEditor.columnFormulaInsertMinutes" },
      { token: "{{range.seconds}}", labelKey: "visualEditor.columnFormulaInsertSeconds" },
      { token: "{{range.weeks}}", labelKey: "visualEditor.columnFormulaInsertWeeks" },
      { token: "{{range.months}}", labelKey: "visualEditor.columnFormulaInsertMonths" },
      { token: "{{range.quarters}}", labelKey: "visualEditor.columnFormulaInsertQuarters" },
      { token: "{{range.years}}", labelKey: "visualEditor.columnFormulaInsertYears" },
      { token: "{{range.weekdays}}", labelKey: "visualEditor.columnFormulaInsertWeekdays" },
      { token: "{{range.weekendDays}}", labelKey: "visualEditor.columnFormulaInsertWeekendDays" },
    ],
  },
  {
    id: "runRate",
    labelKey: "visualEditor.formulaGroupRunRate",
    tokens: [
      { token: "{{range.elapsedDays}}", labelKey: "visualEditor.columnFormulaInsertElapsedDays" },
      { token: "{{range.remainingDays}}", labelKey: "visualEditor.columnFormulaInsertRemainingDays" },
      { token: "{{range.elapsedHours}}", labelKey: "visualEditor.columnFormulaInsertElapsedHours" },
      { token: "{{range.remainingHours}}", labelKey: "visualEditor.columnFormulaInsertRemainingHours" },
      { token: "{{range.isComplete}}", labelKey: "visualEditor.columnFormulaInsertIsComplete" },
    ],
  },
  {
    id: "calendar",
    labelKey: "visualEditor.formulaGroupCalendar",
    tokens: [
      { token: "{{calendar.daysInMonth}}", labelKey: "visualEditor.columnFormulaInsertDaysInMonth" },
      { token: "{{calendar.daysInYear}}", labelKey: "visualEditor.columnFormulaInsertDaysInYear" },
      { token: "{{calendar.dayOfMonth}}", labelKey: "visualEditor.columnFormulaInsertDayOfMonth" },
      { token: "{{calendar.month}}", labelKey: "visualEditor.columnFormulaInsertMonth" },
      { token: "{{calendar.quarter}}", labelKey: "visualEditor.columnFormulaInsertQuarter" },
      { token: "{{calendar.year}}", labelKey: "visualEditor.columnFormulaInsertYear" },
      { token: "{{calendar.isCurrentMonth}}", labelKey: "visualEditor.columnFormulaInsertIsCurrentMonth" },
    ],
  },
  {
    id: "const",
    labelKey: "visualEditor.formulaGroupConst",
    tokens: [
      { token: "{{const.hoursPerDay}}", labelKey: "visualEditor.columnFormulaInsertHoursPerDay" },
      { token: "{{const.daysPerWeek}}", labelKey: "visualEditor.columnFormulaInsertDaysPerWeek" },
    ],
  },
  {
    id: "functions",
    labelKey: "visualEditor.formulaGroupFunctions",
    tokens: [
      { token: "round(", labelKey: "visualEditor.columnFormulaInsertRound" },
      { token: "safeDiv(", labelKey: "visualEditor.columnFormulaInsertSafeDiv" },
      { token: "pct(", labelKey: "visualEditor.columnFormulaInsertPct" },
      { token: "min(", labelKey: "visualEditor.columnFormulaInsertMin" },
      { token: "max(", labelKey: "visualEditor.columnFormulaInsertMax" },
      { token: "if(", labelKey: "visualEditor.columnFormulaInsertIf" },
    ],
  },
];

export function columnFormulaChips(field: string): FormulaTokenChip[] {
  const key = field.trim();
  if (!key) return [];
  return [
    { token: `{{${key}}}`, labelKey: key },
    { token: `{{sum.${key}}}`, labelKey: "visualEditor.columnFormulaInsertSum" },
    { token: `{{prev.${key}}}`, labelKey: "visualEditor.columnFormulaInsertPrev" },
    { token: `{{delta.${key}}}`, labelKey: "visualEditor.columnFormulaInsertDelta" },
    { token: `{{deltaPct.${key}}}`, labelKey: "visualEditor.columnFormulaInsertDeltaPct" },
  ];
}
